import React from 'react';

export function CookiePolicy() {
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <h1 className="text-3xl font-bold mb-6">Gizlilik ve Çerez Politikası</h1>
      <p className="text-muted-foreground mb-6">
        Bu aydınlatma metni, 6698 sayılı Kişisel Verilerin Korunması Kanunu ("KVKK") ve ilgili mevzuat kapsamında,
        İlimera Teknoloji Yazılım LTD. ŞTİ. ("İlimera" veya "Şirket") tarafından işletilen web sitesi ve
        dijital platformlarda çerez (cookie) ve benzeri teknolojiler vasıtasıyla işlenen kişisel verilere ilişkindir.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-3">Çerez Nedir?</h2>
      <p className="mb-4">
        Çerezler, ziyaret ettiğiniz internet siteleri tarafından tarayıcınıza veya cihazınıza yerleştirilen küçük metin
        dosyalarıdır. Çerezler, site deneyiminizin iyileştirilmesi, tercihlerinizin hatırlanması, site performansının
        ölçümlenmesi ve güvenlik gibi amaçlarla kullanılır.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-3">Kullanılan Çerez Türleri</h2>
      <ul className="list-disc pl-6 space-y-2">
        <li>
          <strong>Zorunlu Çerezler:</strong> Sitenin temel işlevleri için gereklidir. Oturumun sürdürülmesi, güvenlik ve
          dolandırıcılığın önlenmesi gibi amaçlarla kullanılır. Açık rızaya tabi değildir.
        </li>
        <li>
          <strong>İşlevsellik Çerezleri:</strong> Tercih ve ayarlarınızın (ör. dil, tema) hatırlanması için kullanılır.
        </li>
        <li>
          <strong>Analitik/Performans Çerezleri:</strong> Site kullanımını ölçmek ve iyileştirmek için (ör. en çok
          ziyaret edilen sayfalar) anonim istatistikler üretir. Bu çerezler açık rızanıza tabidir.
        </li>
        <li>
          <strong>Pazarlama/Tanıtım Çerezleri:</strong> İlgi alanlarınıza uygun içerik ve kampanyalar göstermek için
          kullanılabilir. Açık rızanıza tabidir.
        </li>
      </ul>

      <h2 className="text-2xl font-semibold mt-8 mb-3">Çerezlerin Kullanım Amaçları</h2>
      <ul className="list-disc pl-6 space-y-2">
        <li>Sitenin çalışması için gerekli temel fonksiyonların sağlanması</li>
        <li>Tercihlerin hatırlanması ve kullanıcı deneyiminin iyileştirilmesi</li>
        <li>Site performansının ölçülmesi ve iyileştirilmesi</li>
        <li>Güvenliğin sağlanması ve dolandırıcılığın önlenmesi</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-8 mb-3">Üçüncü Taraf Çerezler</h2>
      <p className="mb-4">
        Sitemizde Google Analytics başta olmak üzere üçüncü taraf servisler tarafından çerezler yerleştirilebilir.
        Üçüncü taraf çerezler, ilgili üçüncü tarafın kontrolündedir. Bu çerezler aracılığıyla toplanan veriler, ilgili
        tarafların gizlilik politikalarına tabidir.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-3">Çerez Tercihleri ve KVKK Açık Rıza</h2>
      <p className="mb-4">
        Analitik ve pazarlama çerezleri açık rızanıza tabidir. Sayfa altındaki çerez banner’ı üzerinden “Kabul Et / Reddet”
        seçeneklerini kullanabilir; dilediğiniz zaman tercihlerinizi güncelleyebilirsiniz.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-3">Çerezleri Yönetme</h2>
      <p className="mb-2">Tarayıcı ayarlarınızdan çerezleri engelleyebilir veya silebilirsiniz:</p>
      <ul className="list-disc pl-6 space-y-1 text-sm">
        <li>Chrome: Settings → Privacy & Security → Cookies</li>
        <li>Safari: Preferences → Privacy → Cookies</li>
        <li>Firefox: Options → Privacy & Security → Cookies</li>
        <li>Edge: Settings → Cookies and site permissions</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-8 mb-3">Kişisel Verilerin İşlenmesinin Hukuki Sebepleri</h2>
      <p className="mb-4">
        Zorunlu çerezler KVKK m.5/2 (sözleşmenin ifası, meşru menfaat, hukuki yükümlülük) kapsamında;
        analitik ve pazarlama çerezleri ise KVKK m.5/1 kapsamında açık rızanıza dayanılarak işlenir.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-3">Veri Saklama</h2>
      <p className="mb-4">
        Çerezler; türüne göre oturum süresince veya azami 24 ay saklanır. Süre sonunda otomatik olarak silinir veya
        anonimleştirilir.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-3">Haklarınız</h2>
      <p className="mb-4 text-sm">
        KVKK m.11 kapsamındaki haklarınız (erişim, düzeltme, silme, itiraz vb.) için bizimle iletişime geçebilirsiniz.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-3">İletişim</h2>
      <div className="space-y-3 text-sm">
        <div><strong>Unvan:</strong> İlimera Teknoloji Yazılım LTD. ŞTİ.</div>
        <div><strong>Web:</strong> https://www.ilimera.com</div>
        <div><strong>E‑posta:</strong> info@ilimera.com</div>
        <div>
          <strong>Genel Merkez:</strong><br />
          Akdeniz Üniversitesi, Teknokent Uluğbey ArGe-2 No:3A/B96 Konyaaltı / ANTALYA
        </div>
        <div>
          <strong>Ar-Ge Merkezi:</strong><br />
          Davraz Mah. 104. Cadde No:44-A Kat:2 Ofis:13/1<br />
          Merkez / ISPARTA
        </div>
      </div>

      <p className="text-xs text-muted-foreground mt-8">
        Bu metin, genel bilgilendirme amaçlıdır. Güncel mevzuat ve şirket süreçlerinize göre hukuk danışmanınızla gözden
        geçirmenizi öneririz.
      </p>
    </div>
  );
}


